import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var header = /*#__PURE__*/css("position:relative;height:60px;display:flex;justify-content:flex-end;align-items:center;padding:0 8px 0 16px;z-index:1000;background:", colors.neutral.surface.default, ";border-bottom:1px solid ", colors.neutral.trim.default, ";");
export var heading = {
  name: "1rr4qq7",
  styles: "flex:1;"
};
export var headingBody = /*#__PURE__*/css(applyFont(typography.heading), ";");